import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download_staging/6a07743df6558f0014905904_1781666673010_dc39368a/kraftsouq_admin/src/app/faqs/components/FAQsContent.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download_staging/6a07743df6558f0014905904_1781666673010_dc39368a/kraftsouq_admin/src/components/Sidebar.tsx");
